import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/assets/videos/launch_video.mp4'
import _imports_1 from '../../../public/assets/img/svg/acon_logo_white.svg'


const _withScopeId = n => (_pushScopeId("data-v-4da2fe2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onended"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_0,
  type: "video/mp4"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "landing_page" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "acon_text",
  class: "acon_logo_white m-4 mt-8 lg:m-16"
}, null, -1))
const _hoisted_7 = { class: "title-container m-4 lg:m-16" }
const _hoisted_8 = { class: "landing_text_header text-5xl md:text-7xl" }
const _hoisted_9 = { class: "landing_text text-2xl md:text-5xl" }
const _hoisted_10 = { class: "bottom-8 left-4 lg:bottom-16 lg:left-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, {
    onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('done'))
  }, {
    default: _withCtx(() => [
      _createElementVNode("video", {
        class: "welcome-video",
        autoplay: "",
        playsinline: "",
        muted: "",
        onended: () => _ctx.$emit('done')
      }, _hoisted_4, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.headerText), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.descText), 1)
        ]),
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.t("einloggen.tagline")), 1)
      ])
    ]),
    _: 1
  }))
}